import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Historico } from "src/components/projetos/historico/Historico";
import { appStore } from "src/framework/store/AppStore";
import { getCategoriasComponentes, getComponentes } from "src/store/global.store";

const PAGE_TITLE = "Histórico Projeto";

const ProjetoHistoricoPage = () => {
    const params: any = useParams();
    useEffect(() => {
        getComponentes();
        getCategoriasComponentes();
        appStore.setPageTitle(PAGE_TITLE);
        return () => {
            appStore.setPageTitle("");
        }
    }, [])


    return (
        <div className="container">
            <div className="row">
                <div className="X12">
                    <Historico
                        codigoProjeto={params?.codigo_projeto} 
                    />
                </div>
            </div>
        </div>
    );
};

export { ProjetoHistoricoPage };
